export default __webpack_public_path__ + "static/media/ddisystemslogo.7a68f602.jpg";